import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import colors from "../Constant/colors";
import { hasPermission } from "../utils/permissionUtils"; 

const UserManagement = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 1024);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 1024);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const cardStyle = {
    background: "#ffffff",
    padding: "20px",
    borderRadius: "14px",
    boxShadow: `0 4px 12px ${colors.cardShadow}`,
    transition: "0.3s",
    display: "flex",
    alignItems: "center",
    gap: "12px",
    minHeight: "120px",
    height: "100%",
  };

  const heading = {
    fontSize: "18px",
    fontWeight: "600",
    color: colors.grayDark,
  };

  const subText = {
    color: colors.grayDark,
    opacity: 0.85,
    fontSize: "12px",
    marginTop: "2px",
  };

  const iconStyle = {
    fontSize: "32px",
    minWidth: "40px",
  };

  return (
    <div
      style={{ background: "#fff", minHeight: "100vh" }}
      className="flex justify-center items-start p-6"
    >
      <div className="w-full max-w-7xl">

        <div
          className={`grid gap-6 ${
            isMobile ? "grid-cols-1" : "grid-cols-3"
          }`}
        >

          {/* 🔹 NEW ROLES */}
          {hasPermission("new_role") && (
            <Link to="/new-roles" className="flex">
              <div style={cardStyle} className="hover:scale-[1.02] w-full">
                <i
                  className="fas fa-user-plus"
                  style={{ ...iconStyle, color: "#3B82F6" }}
                />
                <div>
                  <h2 style={heading}>New Roles</h2>
                  <p style={subText}>Assign new roles to users.</p>
                </div>
              </div>
            </Link>
          )}

          {/* 🔹 PERMISSIONS */}
          {hasPermission("permission") && (
            <Link to="/permissions" className="flex">
              <div style={cardStyle} className="hover:scale-[1.02] w-full">
                <i
                  className="fas fa-user-edit"
                  style={{ ...iconStyle, color: "#F97316" }}
                />
                <div>
                  <h2 style={heading}>Permissions</h2>
                  <p style={subText}>Grant permissions to users.</p>
                </div>
              </div>
            </Link>
          )}

          {/* 🔹 RESET PASSWORD */}
          {hasPermission("reset_password") && (
            <Link to="/reset-password" className="flex">
              <div style={cardStyle} className="hover:scale-[1.02] w-full">
                <i
                  className="fas fa-mobile-alt"
                  style={{ ...iconStyle, color: "#10B981" }}
                />
                <div>
                  <h2 style={heading}>Reset Passwords</h2>
                  <p style={subText}>Reset user passwords easily.</p>
                </div>
              </div>
            </Link>
          )}

          {/* 🔹 SCHOOL DETAILS */}
          {hasPermission("school_details") && (
            <Link to="/school-data" className="flex">
              <div style={cardStyle} className="hover:scale-[1.02] w-full">
                <i
                  className="fas fa-school"
                  style={{ ...iconStyle, color: "#EF4444" }}
                />
                <div>
                  <h2 style={heading}>School Details</h2>
                  <p style={subText}>Add and update school details.</p>
                </div>
              </div>
            </Link>
          )}

        </div>
      </div>
    </div>
  );
};

export default UserManagement;
